import { SET_ALL_BOARDS_NOTES } from "../types";
import configVars from "../../config";

export const getNotesFromApi = (boardId) => async (dispatch) => {
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/get-board-notes`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ board_id: boardId }),
      }
    );
    const data = await response.json();
    dispatch({
      type: SET_ALL_BOARDS_NOTES,
      payload: { notes: data?.data, boardId: boardId },
    });
  } catch (error) {
    console.log("Error herer ", error);
  }
};
